import { Service } from 'typedi';
import { axios } from '../axios';
import { ShowNotification } from '../ShowNotification';
import { IScheduleCalendarMeetingResponse, IScheduleMeetingsRequest, ICalendarMeetingsColor } from '../../types';
import { AxiosResponse } from 'axios';

@Service()
export class ScheduleCalendarRequest {
  @ShowNotification()
  getScheduleMeetings(body: IScheduleMeetingsRequest): Promise<AxiosResponse<IScheduleCalendarMeetingResponse[]>> {
    return axios.post('/mobile/meetings', body);
  }

  @ShowNotification()
  getMeetingsColors(
    startIntervalDate: string, endIntervalDate: string
  ): Promise<AxiosResponse<ICalendarMeetingsColor[]>> {
    return axios.post('/mobile/color-meetings', {
      startIntervalDate, 
      endIntervalDate, 
      splitByUserId: false,
    });
  }
}
